import { Routes } from '@angular/router';
import { appResolver } from '@app/core/resolvers';

export const routes: Routes = [
    {
        path: '',
        resolve: {
            config: appResolver,
        },
        loadComponent: () => import('./shared/components/layouts/master-layout/master-layout.component').then((m) => m.MasterLayoutComponent),
        loadChildren: () => import('./modules/routes').then((m) => m.routes),
    }
];
